function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1980(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 7.58,
    height: 3.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.5783333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 1.735
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 3.47,
    width: 7.58,
    height: 12.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 9.935
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.4,
    width: 7.58,
    height: 25.75,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 29.275
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42.16,
    width: 7.58,
    height: 30.11,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.516
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 57.214999999999996
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 72.27,
    width: 7.58,
    height: 37.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.2633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 91.07
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 109.88,
    width: 7.58,
    height: 41.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.082857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 130.755
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 151.63,
    width: 7.58,
    height: 42.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.9475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 172.74
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 193.85,
    width: 7.58,
    height: 52.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.8422222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 220.15
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 246.45,
    width: 7.58,
    height: 57.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.758
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 275.065
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 303.68,
    width: 7.58,
    height: 60.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 333.895
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 364.11,
    width: 7.58,
    height: 61.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 394.83000000000004
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 425.55,
    width: 7.58,
    height: 61.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 456.41
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 487.27,
    width: 7.58,
    height: 62.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.516
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 518.56
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 549.85,
    width: 7.58,
    height: 72.8,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.2633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 586.25
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 622.65,
    width: 7.58,
    height: 77.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.8422222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.79,
    y: 661.3249999999999
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.58,
    y: 0,
    width: 20.54,
    height: 39.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.85,
    y: 19.605
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.12,
    y: 0,
    width: 22.5,
    height: 39.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.370000000000005,
    y: 19.605
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.62,
    y: 0,
    width: 23.38,
    height: 39.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.309999999999995,
    y: 19.605
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 0,
    width: 24.24,
    height: 39.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.12,
    y: 19.605
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.24,
    y: 0,
    width: 24.36,
    height: 39.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.41999999999999,
    y: 19.605
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.6,
    y: 0,
    width: 27.01,
    height: 39.21,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.501666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.105,
    y: 19.605
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.61,
    y: 0,
    width: 27.69,
    height: 39.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.538
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.455,
    y: 19.605
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.29,
    y: 0,
    width: 28.79,
    height: 39.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.798333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.685,
    y: 19.605
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.08,
    y: 0,
    width: 31.41,
    height: 39.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.92625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.78500000000003,
    y: 19.605
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.49,
    y: 0,
    width: 38.22,
    height: 39.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.6,
    y: 19.605
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.71,
    y: 0,
    width: 41.08,
    height: 39.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3566666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.25,
    y: 19.605
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.8,
    y: 0,
    width: 53.05,
    height: 39.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.3566666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.325,
    y: 19.605
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.85,
    y: 0,
    width: 53.85,
    height: 39.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 396.77500000000003,
    y: 19.605
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.69,
    y: 0,
    width: 64.09,
    height: 39.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.8025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 455.735,
    y: 19.605
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.79,
    y: 0,
    width: 69.02,
    height: 39.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 522.3000000000001,
    y: 19.605
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.8,
    y: 0,
    width: 70.87,
    height: 39.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.90125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 592.2349999999999,
    y: 19.605
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.68,
    y: 0,
    width: 72.32,
    height: 39.21,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.8025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.8399999999999,
    y: 19.605
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.58,
    y: 39.21,
    width: 60.79,
    height: 48.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.049999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.975,
    y: 63.36
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.58,
    y: 87.51,
    width: 60.79,
    height: 61.98,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.158
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.975,
    y: 118.5
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.58,
    y: 149.49,
    width: 60.79,
    height: 65.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.052666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.975,
    y: 182.13
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.58,
    y: 214.76,
    width: 60.79,
    height: 66.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.131666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.975,
    y: 248.01999999999998
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.58,
    y: 281.28,
    width: 60.79,
    height: 75.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.131666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.975,
    y: 319.155
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.58,
    y: 357.03,
    width: 60.79,
    height: 79.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.079
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.975,
    y: 396.54999999999995
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.58,
    y: 436.07,
    width: 60.79,
    height: 80.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.079
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.975,
    y: 476.35
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.58,
    y: 516.63,
    width: 60.79,
    height: 81.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.59875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.975,
    y: 557.375
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.58,
    y: 598.12,
    width: 60.79,
    height: 101.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.158
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.975,
    y: 649.06
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.37,
    y: 39.21,
    width: 68.05,
    height: 98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1863636363636365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.39500000000001,
    y: 88.21000000000001
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.42,
    y: 39.21,
    width: 71.12,
    height: 98,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.98,
    y: 88.21000000000001
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.54,
    y: 39.21,
    width: 73.37,
    height: 98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.228333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.225,
    y: 88.21000000000001
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.9,
    y: 39.21,
    width: 75.12,
    height: 98,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.7784615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.46,
    y: 88.21000000000001
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.02,
    y: 39.21,
    width: 93.98,
    height: 98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.663333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.01,
    y: 88.21000000000001
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.01,
    y: 39.21,
    width: 111.02,
    height: 98,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.52,
    y: 88.21000000000001
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 561.03,
    y: 39.21,
    width: 138.97,
    height: 98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.88888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.515,
    y: 88.21000000000001
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.37,
    y: 137.21,
    width: 108.98,
    height: 127.4,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.10888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.86000000000001,
    y: 200.91000000000003
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.37,
    y: 264.61,
    width: 108.98,
    height: 133.03,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.383076923076924
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.86000000000001,
    y: 331.125
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.37,
    y: 397.65,
    width: 108.98,
    height: 150.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.081666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.86000000000001,
    y: 472.94
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.37,
    y: 548.23,
    width: 108.98,
    height: 151.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.784285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.86000000000001,
    y: 624.115
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.34,
    y: 137.21,
    width: 138.37,
    height: 132.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.286000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.525,
    y: 203.64000000000001
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.71,
    y: 137.21,
    width: 179.39,
    height: 132.86,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.405,
    y: 203.64000000000001
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.1,
    y: 137.21,
    width: 204.9,
    height: 132.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.07818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 597.5500000000001,
    y: 203.64000000000001
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.34,
    y: 270.07,
    width: 198.73,
    height: 205.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.08111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.705,
    y: 373.005
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.34,
    y: 475.94,
    width: 198.73,
    height: 224.06,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 33.12166666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.705,
    y: 587.97
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.08,
    y: 270.07,
    width: 323.92,
    height: 429.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 29.44727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.04,
    y: 485.03499999999997
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1980);
export default __webpack_public_path__ + "static/media/1980.249579ab3b9ccf63a06de876a86bdce8.svg";
export { ForwardRef as ReactComponent };